import { createSlice } from '@reduxjs/toolkit'

export const printerSlice = createSlice({
    name: 'auth/printers',
    initialState: {
        printers: [],
    },
    reducers: {
        setPrinters: (_, action) => action.payload,
    },
})

export const { setPrinters } = printerSlice.actions

export default printerSlice.reducer
